<template>
  <div>
    <a-card class="customer-filter" size="small">
      <a-form-model :form="filterForm" :label-col="{ span: 7 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="评审标题">
              <a-input v-model="filterForm.title" allow-clear placeholder="评审标题" class="form-model-item" @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="状态">
              <a-select v-model="filterForm.status" mode="multiple" allow-clear placeholder="状态" @change="onSearch">
                <a-select-option v-for="(item, index) in reviewStatus" :key="index" :value="item.value">
                  <a-tag :color="item.color">{{ item.label }}</a-tag>
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="评审类型">
              <a-select v-model="filterForm.review_scope" mode="multiple" allow-clear placeholder="评审类型" @change="onSearch">
                <a-select-option v-for="(item, index) in reviewTypes" :key="index" :value="item.value">{{ item.label }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="参与人">
              <user-select v-model="filterForm.reviewers" mode="multiple" allow-clear show-search show-all placeholder="评审参与人" :project-id="projectId" @change="onSearch" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="创建人">
              <user-select v-model="filterForm.creator" mode="multiple" allow-clear show-search show-all placeholder="创建人" :project-id="projectId" @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item v-show="expand" label="时间筛选" :label-col="{ span: 3 }">
              <a-input-group compact>
                <a-select v-model="filterForm.time_field" style="width: 30%" @change="onSearch">
                  <a-select-option value="review_time"> 计划时间 </a-select-option>
                  <a-select-option value="created_time"> 创建时间 </a-select-option>
                  <a-select-option value="updated_time"> 更新时间 </a-select-option>
                </a-select>
                <a-date-picker v-model="filterForm.start_time" style="width: 35%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="onSearch" />
                <a-date-picker v-model="filterForm.end_time" style="width: 35%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="onSearch" />
              </a-input-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-button v-tc="{ name: '查询' }" type="primary" @click="getReviewList">查询</a-button>
            <a-button v-tc="{ name: '重置' }" :style="{ margin: '0 8px' }" @click="reset">重置</a-button>
            <a v-tc="{ name: '展开/收起' }" class="ant-dropdown-link" @click="expand = !expand">
              {{ expand ? '收起' : '展开' }}
              <a-icon :type="expand ? 'up' : 'down'" />
            </a>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="评审列表" size="small" class="filter-data">
      <span slot="extra">
        <a-button v-tc="{ name: '添加评审' }" class="handle-menu" type="link" icon="plus" @click="onAdd">添加</a-button>
      </span>
      <a-table :scroll="{ x: 1600 }" :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" :loading="loading" row-key="id" @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a-dropdown placement="bottomCenter">
            <a-icon type="more" />
            <a-menu slot="overlay">
              <a-menu-item>
                <a v-tc="{ name: '编辑' }" class="ant-dropdown-link" @click="onEdit(record)"><a-icon type="edit" /> 编辑</a>
              </a-menu-item>
              <a-menu-item>
                <a v-tc="{ name: '复制' }" class="ant-dropdown-link" @click="onCopy(record)"><a-icon type="copy" /> 复制</a>
              </a-menu-item>
              <a-menu-item v-if="record.review_scope === 2">
                <a v-tc="{ name: '关联用例' }" class="ant-dropdown-link" @click="onAddCase(record)"><a-icon type="plus" /> 关联用例</a>
              </a-menu-item>
              <a-menu-item v-if="record.review_scope === 1">
                <a v-tc="{ name: '关联需求' }" class="ant-dropdown-link" @click="onAddStory(record)"><a-icon type="plus" /> 关联需求</a>
              </a-menu-item>
              <a-menu-item v-if="record.has_delete_permission">
                <a v-tc="{ name: '删除' }" class="ant-dropdown-link" @click="onDelete(record.id)"><a-icon type="delete" /> 删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
        <span slot="reviewTitle" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.title">
            <a v-tc="{ name: '跳转评审详情' }" class="custom-link" :href="reviewLink(record)" target="_blank"> {{ record.title }} </a>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text, record">
          <review-status-edit :review-id="record.id" :next-status="record.next_status" :status="record.status" @change="getReviewList" />
        </span>
        <span slot="reviewScope" slot-scope="text, record">
          <a-badge v-if="record.review_scope !== null && reviewTypes[record.review_scope]" :color="reviewTypes[record.review_scope].color" :text="reviewTypes[record.review_scope].label" />
        </span>
        <span slot="progress" slot-scope="text, record">
          <a-popover placement="topLeft">
            <template slot="content">
              <span>
                已评审/总数: <span style="font-weight: bold">{{ record.finished_items }}/{{ record.total_items }}</span>
              </span>
            </template>
            <a-progress :percent="record.progress" size="small" style="width: 150px" />
          </a-popover>
        </span>
        <span slot="reviewers" slot-scope="text, record">
          <span v-if="reviewers(record).length !== 0">
            <a-popover placement="topLeft">
              <template slot="content">
                <user-profiles :value="record.reviewers.map(item => item.id)" avatar />
              </template>
              <span slot="title">参与人</span>
              <span>{{ record.reviewers.map(item => item.nickname).join(';') }}</span>
            </a-popover>
          </span>
          <span v-else> -- </span>
        </span>
        <span slot="reviewTime" slot-scope="text, record">
          <review-date-edit :data-source="record" item-name="review_time" @change="getReviewList" />
        </span>
        <span slot="creator" slot-scope="text, record"><user-profiles :value="[record.creator.id]" avatar /></span>
      </a-table>
    </a-card>
    <review-modal :is-show="modalVisible" :review-id="reviewId" @close="close" />
    <case-selector :is-show="caseSelectorVisible" :plan-bind-keys="reviewBindCases" @close="closeCaseSelector" />
    <story-selector :is-show="storySelectorVisible" :data="storyData" :plan-bind-keys="reviewBindStories" :total="storyTotal" @close="closeStorySelector" @change="pageChange" @search="getStoryList" />
  </div>
</template>

<script>
import { storyTree } from '@/api/project/story';
import { moduleList } from '@/api/project/case';
import { reviewStatus, reviewTypes } from '@/utils/dictionary';
import { bindStories, bindTestCases, reviewBindCaseIds, reviewBindStoryIds, reviewCopy, reviewDelete, reviewList } from '@/api/project/review';

import UserSelect from '@/components/User/UserSelect';
import ReviewModal from '@/pages/project/review/components/ReviewModal';
import CaseSelector from '@/pages/project/testplan/components/CaseSelector';
import StorySelector from '@/pages/project/review/components/StorySelector';
import ReviewDateEdit from '@/pages/project/review/components/ReviewDateEdit';
import ReviewStatusEdit from '@/pages/project/review/components/ReviewStatusEdit';

const columns = [
  {
    align: 'center',
    width: 30,
    fixed: 'left',
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
    width: 80,
    fixed: 'left',
    ellipsis: true
  },
  {
    title: '评审标题',
    width: 280,
    ellipsis: true,
    fixed: 'left',
    scopedSlots: { customRender: 'reviewTitle' }
  },
  {
    title: '状态',
    width: 100,
    fixed: 'left',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '评审进度',
    width: 160,
    fixed: 'left',
    scopedSlots: { customRender: 'progress' }
  },
  {
    title: '评审类型',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'reviewScope' }
  },
  {
    width: 150,
    title: '参与人',
    ellipsis: true,
    scopedSlots: { customRender: 'reviewers' }
  },
  {
    title: '计划评审时间',
    width: 180,
    align: 'center',
    scopedSlots: { customRender: 'reviewTime' }
  },
  {
    title: '创建人',
    width: 100,
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '创建时间',
    width: 180,
    align: 'center',
    dataIndex: 'created_time',
    key: 'created_time'
  },
  {
    title: '更新时间',
    width: 180,
    align: 'center',
    dataIndex: 'updated_time',
    key: 'updated_time'
  }
];

export default {
  name: 'Index',
  components: { UserSelect, ReviewModal, ReviewStatusEdit, ReviewDateEdit, CaseSelector, StorySelector },
  data() {
    return {
      columns,
      reviewStatus,
      reviewTypes,
      projectId: parseInt(this.$route.params.project_id) || null,
      loading: false,
      expand: true,
      tableData: [],
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 20, // 每页中显示20条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      filterForm: {
        title: '',
        page_size: 20,
        page_number: 1,
        time_field: 'review_time'
      },
      modalVisible: false,
      reviewId: null,
      caseSelectorVisible: false,
      storySelectorVisible: false,
      caseData: [],
      storyData: [],
      reviewBindCases: [],
      reviewBindStories: [],
      moduleCases: {},
      storyTotal: 0
    };
  },
  computed: {
    reviewers() {
      return record => {
        return record.reviewers || null;
      };
    },
    reviewLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:review:detail',
          query: { reviewId: record.id }
        });
        return route.href;
      };
    }
  },
  mounted() {
    this.getReviewList();
  },
  methods: {
    onAddCase(review) {
      this.reviewId = review.id;
      reviewBindCaseIds({ review_id: this.reviewId }).then(res => {
        this.reviewBindCases = res.data.items;
        this.caseSelectorVisible = true;
      });
    },
    onAddStory(review) {
      this.reviewId = review.id;
      this.getStoryList();
      reviewBindStoryIds({ review_id: this.reviewId }).then(res => {
        this.reviewBindStories = res.data.items;
        this.storySelectorVisible = true;
      });
    },
    closeCaseSelector(targetKeys = null) {
      if (targetKeys !== null) {
        this.bindCases(targetKeys);
      } else {
        this.caseSelectorVisible = false;
      }
    },
    closeStorySelector(targetKeys = null) {
      if (targetKeys !== null) {
        this.bindStories(targetKeys);
      } else {
        this.storySelectorVisible = false;
      }
    },
    bindCases(testCases) {
      bindTestCases({ review_id: this.reviewId, cases: testCases })
        .then(() => {
          this.caseSelectorVisible = false;
          this.$message.success('关联用例成功');
        })
        .catch(() => {
          this.caseSelectorVisible = false;
        });
    },
    bindStories(stories) {
      bindStories({ review_id: this.reviewId, stories: stories })
        .then(() => {
          this.storySelectorVisible = false;
          this.$message.success('关联需求成功');
        })
        .catch(() => {
          this.storySelectorVisible = false;
        });
    },
    getStoryList(page_number = 1, title = null) {
      if (title === '') {
        title = null;
      }
      this.storyData = [];
      this.expendedKeys = [];
      storyTree({ project_id: this.projectId, page_number: page_number, page_size: 20, title: title }).then(res => {
        this.storyData = res.data.items;
        this.expendedKeys = res.data.requirement_ids;
        this.storyTotal = res.data.total;
      });
    },
    pageChange(page_number = 1) {
      this.getStoryList(page_number);
    },
    getCaseList() {
      moduleList({ project_id: this.projectId, detailed: true }).then(res => {
        this.moduleCases = res.data.module_cases;
        const items = res.data.items.map(item => {
          return {
            id: item.id,
            title: item.title,
            key: 'module-' + item.key,
            children: [],
            parent_id: item.parent_id
          };
        });
        const caseData = [
          {
            id: 0,
            key: 'module-0',
            title: '未分配',
            children: this.moduleCases['null']
          },
          ...this.listToTree(items)
        ];
        this.caseData = caseData;
      });
    },
    listToTree(list, parentId = 0) {
      const menuObj = {};
      const tempArr = [];
      list.forEach(item => {
        const temp = {
          ...item,
          children: this.moduleCases[item.id.toString()] || []
        };
        tempArr.push(temp);
        menuObj[item.id] = temp;
      });

      return tempArr.filter(item => {
        if (item.parent_id !== parentId) {
          menuObj[item.parent_id].children.push(item);
          return false;
        }
        return true;
      });
    },
    getReviewList() {
      this.loading = true;
      reviewList({ ...this.filterForm, project_id: this.projectId })
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onAdd() {
      this.modalVisible = true;
      this.reviewId = null;
    },
    onEdit(record) {
      this.reviewId = record.id;
      this.modalVisible = true;
    },
    onCopy(record) {
      reviewCopy({ review_id: record.id }).then(() => {
        this.$message.success('复制评审单成功');
        this.getReviewList();
      });
    },
    handleTableChange(pagination) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.getReviewList();
    },
    onDelete(id) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该评审单吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          reviewDelete({ project_id: self.projectId, review_id: id }).then(() => {
            self.$message.success('删除成功');
            self.getReviewList();
          });
        }
      });
    },
    close() {
      this.reviewId = null;
      this.modalVisible = false;
      this.getReviewList();
    },
    reset() {
      this.setFilter({ start_time: null, end_time: null });
      // this.$refs['view'].resetView();
    },

    setFilter(filter) {
      this.filterForm = {
        ...filter,
        page_size: 20,
        page_number: 1
      };
      if (!this.filterForm.time_field) {
        this.filterForm.time_field = 'review_time';
      }
      this.pagination.pageSize = 20;
      this.pagination.current = 1;
      this.getReviewList();
    },
    onSearch() {
      this.pagination.current = 1;
      this.filterForm.page_number = 1;
      this.getReviewList();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }

  margin-bottom: 16px;

  .ant-form-item {
    margin-bottom: 8px;
    display: flex;

    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }

  .filter-right {
    float: right;
    text-align: right;
  }
}

.custom-link {
  color: rgba(0, 0, 0, 0.65);
}

.custom-link:hover {
  color: #1890ff;
}

.customer-date-picker {
  width: calc(50% - 3px);
}
</style>
